import { render, staticRenderFns } from "./ConfigTabColunas.vue?vue&type=template&id=0b14bbbe&scoped=true"
import script from "./ConfigTabColunas.vue?vue&type=script&lang=js"
export * from "./ConfigTabColunas.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabColunas.vue?vue&type=style&index=0&id=0b14bbbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b14bbbe",
  null
  
)

export default component.exports